query MobileSdkTests(
	$offset: Int!
	$limit: Int!
	$sort: msdk_report_runsSort
	$textSearch: msdk_report_runsSearchInsensitive
	$textSearchExact: msdk_report_runsSearchInsensitive
	$daysAmountFilter: ConditionInt
	$customFieldsFilter: ConditionStringArray
	$osFilter: ConditionString
	$appFilter: ConditionString
	$appVersionFilter: ConditionString
	$sdkTypeFilter: ConditionString
	$sdkVersionFilter: ConditionString
	$severityOrFilter: [msdk_report_runsOrFilter!]
) {
	msdk_report_runs(
		offset: $offset
		limit: $limit
		sort: $sort
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $osFilter
		app_eq_any_item: $appFilter
		app_version_eq_any_item: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq_any_item: $sdkVersionFilter
		or: $severityOrFilter
	) {
		run_id
		test_name
		total_scans
		total_issues
		critical_issues
		run_time
		custom_fields
		app
        app_id
		app_version
		os
		sdk_type
		product_version
		mobile_kit
		device_manufacturer
		device_model
		device_type
		os_version
		app_build_number
	}
	total: msdk_report_runs(
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $osFilter
		app_eq_any_item: $appFilter
		app_version_eq_any_item: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq_any_item: $sdkVersionFilter
		or: $severityOrFilter
	) {
		run_id_count
	}
	unfiltered_total: msdk_report_runs {
		run_id_count
	}
}

query RecentMobileSdkTests(
	$offset: Int!
	$limit: Int!
	$sort: msdk_report_runs_latestSort
	$textSearch: msdk_report_runs_latestSearchInsensitive
	$textSearchExact: msdk_report_runs_latestSearchInsensitive
	$daysAmountFilter: ConditionInt
	$customFieldsFilter: ConditionStringArray
	$osFilter: ConditionString
	$appFilter: ConditionString
	$appVersionFilter: ConditionString
	$sdkTypeFilter: ConditionString
	$sdkVersionFilter: ConditionString
	$severityOrFilter: [msdk_report_runs_latestOrFilter!]
) {
	msdk_report_runs: msdk_report_runs_latest(
		offset: $offset
		limit: $limit
		sort: $sort
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $osFilter
		app_eq_any_item: $appFilter
		app_version_eq_any_item: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq_any_item: $sdkVersionFilter
		or: $severityOrFilter
	) {
		run_id
		test_name
		total_scans
		total_issues
		critical_issues
		run_time
		custom_fields
		app
		app_id
		app_version
		os
		sdk_type
		product_version
		mobile_kit
		device_manufacturer
		device_model
		device_type
		os_version
		app_build_number
	}
	total: msdk_report_runs_latest(
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $osFilter
		app_eq_any_item: $appFilter
		app_version_eq_any_item: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq_any_item: $sdkVersionFilter
		or: $severityOrFilter
	) {
		run_id_count
	}
	unfiltered_total: msdk_report_runs {
		run_id_count
	}
}
